import { AppState } from '../../types/store';
import { getModuleData, getModuleIdByModuleType } from './modules';
import { ModuleType } from '../../types/modules';
import { PapiBadge } from '@wix/da-papi-types';

export const getAboutMeData = (state: AppState, moduleId: number) =>
  getModuleData(state, moduleId) || {};

export const getBadges = (state: AppState, moduleId: number) =>
  getAboutMeData(state, moduleId).badges;

export const hasBadgesInstalled = (state: AppState) => {
  return getModuleIdByModuleType(state, ModuleType.ABOUT) ? true : false;
};

// Filter out available routes depending on features and ownership
export const hasSpecificBadge = (
  state: AppState,
  badgeTypeId: PapiBadge['typeId']
) => {
  const aboutMeModuleId = getModuleIdByModuleType(state, ModuleType.ABOUT);
  if (aboutMeModuleId) {
    const badges = getBadges(state, aboutMeModuleId);
    return badges.find(badge => badge.typeId === badgeTypeId);
  }

  // fallback option
  return state.profileOwner.hasAprilFoolsBadge;
};

export const hasPublicBirthday = (state: AppState) => {
  const aboutMeModuleId = getModuleIdByModuleType(state, ModuleType.ABOUT);
  if (aboutMeModuleId) {
    const aboutMeData = getAboutMeData(state, aboutMeModuleId);
    return aboutMeData && aboutMeData.dobMonth;
  }

  return false;
};
